import React from "react";
import { cn } from "../../../common/u1/cn";
import { CheckIcon } from "../../../../assets/ui/icons";

/* Where a verification request has got to. */
const NODE = "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full";

export const TimelineStep = ({ state = "todo", label, sub, last = false }) => {
  const done = state === "done";
  const current = state === "current";

  return (
    <li className="flex items-start gap-3.5">
      <div className="flex flex-col items-center self-stretch">
        {done ? (
          <span className={cn(NODE, "bg-[var(--success)] text-white")} aria-hidden="true">
            <CheckIcon size={13} stroke="currentColor" />
          </span>
        ) : current ? (
          <span
            className={cn(NODE, "border-2 border-[var(--coral)] bg-white")}
            aria-hidden="true"
          >
            <span className="h-2 w-2 rounded-full bg-[var(--coral)]" />
          </span>
        ) : (
          <span className={cn(NODE, "border-2 border-[var(--slate-3)] bg-white")} aria-hidden="true" />
        )}
        {!last && <span aria-hidden="true" className="min-h-[22px] w-0.5 flex-1 bg-[var(--slate-3)]" />}
      </div>

      <div className={cn("min-w-0", last ? "pb-0" : "pb-3.5")}>
        <div
          className={cn(
            "text-[14px] font-semibold font-sans",
            done || current ? "text-[var(--ink)]" : "text-[var(--muted-2)]"
          )}
        >
          {label}
        </div>
        {sub && (
          <div
            className={cn(
              "text-[12.5px] font-sans",
              done || current ? "text-[var(--muted)]" : "text-[var(--muted-2)]"
            )}
          >
            {sub}
          </div>
        )}
      </div>
    </li>
  );
};

export const VerificationTimeline = ({ steps = [], className = "" }) => (
  <ol className={cn("m-0 flex list-none flex-col p-0", className)}>
    {steps.map((step, i) => (
      <TimelineStep
        key={step.label}
        state={step.state}
        label={step.label}
        sub={step.sub}
        last={i === steps.length - 1}
      />
    ))}
  </ol>
);

export default VerificationTimeline;
